var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Tooltip } from '@robinpowered/ui-kit';
import { useMemo } from 'react';
import moment from 'moment';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { useTranslation } from 'react-i18next';
import { useEditFooterMatrix, } from '../hooks/useEditFooterMatrix';
var DISABLED_TOOLTIP_KEYS = {
    isRedirectingToOldComposer: 'eventDetails.footer.edit_tooltip_disabled_redirecting',
    pastEvent: 'eventDetails.footer.edit_tooltip_disabled_past_event',
    notRobinEventAndCannotEditSynced: 'eventDetails.footer.edit_tooltip_disabled_not_robin',
    noUserPermissionAndNoManagePermission: 'eventDetails.footer.edit_tooltip_disabled_no_permission',
};
var creationType = {
    MANUAL: 'manual',
    AUTO: 'auto',
};
export var FooterButtons = function (_a) {
    var _b, _c, _d;
    var onClickEdit = _a.onClickEdit;
    var t = useTranslation('meetingRooms').t;
    var _e = useEventDetailContext(), event = _e.event, spaceData = _e.spaceData, canEditSyncedEvents = _e.canEditSyncedEvents, setShowDeleteModal = _e.setShowDeleteModal, parsedDateTime = _e.parsedDateTime;
    var spaces = useMemo(function () { return Array.from(spaceData.values()); }, [spaceData]);
    var isRobinEvent = (event === null || event === void 0 ? void 0 : event.creation_type) === creationType.MANUAL ||
        (event === null || event === void 0 ? void 0 : event.creation_type) === creationType.AUTO;
    var isPastEvent = parsedDateTime
        ? parsedDateTime.endTime.isBefore(moment.now())
        : false;
    /* Main space on the event */
    var space = useMemo(function () { return spaces.find(function (space) { return Number(space.id) === (event === null || event === void 0 ? void 0 : event.space_id); }); }, [spaces, event === null || event === void 0 ? void 0 : event.space_id]);
    var hasEventsManagePermission = !!((_b = space === null || space === void 0 ? void 0 : space.permissions) === null || _b === void 0 ? void 0 : _b['events:manage']);
    var _f = useEditFooterMatrix({
        event_permissions: event === null || event === void 0 ? void 0 : event.event_permissions,
        isPastEvent: isPastEvent,
        isRobinEvent: isRobinEvent,
        canEditSyncedEvents: canEditSyncedEvents,
        hasEventsManagePermission: hasEventsManagePermission,
        // The legacy `/event-composer/<id>` redirect path (and its
        // `isRedirectingToOldComposer` state) was removed when the shell took
        // over hosting the composer. Always pass `false` so the helper's
        // redirect-aware branches no-op without changing its signature.
        isRedirectingToOldComposer: false,
    }), updateAsSpace = _f.updateAsSpace, isEditButtonDisabled = _f.isEditButtonDisabled, deleteAsSpace = _f.deleteAsSpace, isDeleteButtonDisabled = _f.isDeleteButtonDisabled, primaryEditDisabledReason = _f.primaryEditDisabledReason, primaryCancelDisabledReason = _f.primaryCancelDisabledReason;
    return (_jsxs(DrawerFooter, { children: [_jsx(Tooltip, { title: isEditButtonDisabled && primaryEditDisabledReason
                    ? t(DISABLED_TOOLTIP_KEYS[primaryEditDisabledReason])
                    : updateAsSpace && !((_c = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _c === void 0 ? void 0 : _c.update)
                        ? t('eventDetails.footer.edit_tooltip_space')
                        : null, children: _jsx(Button, { type: "default", size: "large", disabled: isEditButtonDisabled, onClick: function () {
                        onClickEdit((event === null || event === void 0 ? void 0 : event.id) || '');
                    }, style: { flex: 1 }, children: t('eventDetails.footer.edit') }) }), _jsx(Tooltip, { title: isDeleteButtonDisabled && primaryCancelDisabledReason
                    ? t(DISABLED_TOOLTIP_KEYS[primaryCancelDisabledReason])
                    : deleteAsSpace && !((_d = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _d === void 0 ? void 0 : _d.cancel)
                        ? t('eventDetails.footer.cancel_tooltip_space')
                        : null, children: _jsx(Button, { disabled: isDeleteButtonDisabled, size: "large", danger: true, onClick: function () {
                        setShowDeleteModal(true);
                    }, style: { flex: 1 }, children: t('eventDetails.footer.delete') }) })] }));
};
var DrawerFooter = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid var(--ant-color-border-secondary, #f0f0f0);\n\n  padding: 16px;\n  gap: 16px;\n"], ["\n  border-top: 1px solid var(--ant-color-border-secondary, #f0f0f0);\n\n  padding: 16px;\n  gap: 16px;\n"])));
var templateObject_1;
